var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getMenuType,attrs:{"id":"app-container"}},[_c('top-nav'),_c('sidebar'),_c('main',[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }